import {
  INIT_LOAD_FEEDBACK_PENDING,
  INIT_LOAD_FEEDBACK_FULFILLED,
  INIT_LOAD_FEEDBACK_REJECTED
} from "../actions/types";

const initialState = {
  initialLoadComplete: false,
  loading: true,
  pageTitle: "Loading...",
  maxTotal: 0,
  offset: 0,
  feedback: [],
  error: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case INIT_LOAD_FEEDBACK_PENDING: {
      return {
        ...state,
        loading: true
      };
    }
    case INIT_LOAD_FEEDBACK_FULFILLED:
      return {
        ...state,
        initialLoadComplete: true,
        loading: false,
        feedback: state.feedback.concat(action.payload.data),
        maxTotal: action.payload.headers["x-wp-total"],
        offset: state.offset + action.payload.data.length
      };
    case INIT_LOAD_FEEDBACK_REJECTED:
      return {
        ...state,
        error: true,
        loading: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/feedback-reducer.js